import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useMutation } from 'react-query'
import requestApi from '../../utils/request'
import Swal from 'sweetalert2'
import { useAdminInfo } from '../../context/AdminContextDetail'
import { forgotpassword, home } from '../../Routes/routingConsts'
import { ReactComponent as LoginIcon } from '../../assets/images/login.svg'
import { ReactComponent as Logo } from '../../assets/images/admin-logo.svg'
import InputControl from '../../components/InputControl'
import PasswordInput from '../../components/PasswordInput'
import ButtonWithLoader from '../../components/ButtonWithLoader'

const loginFormValidationSchema = yup.object().shape({
    email: yup
        .string()
        .email('Please enter a valid email')
        .required('Please enter email'),
    password: yup
        .string()
        .required('Please enter password')
        .min(6, 'Password must have atleast 6 characters')
})

export function adminLogin({ email, password }) {
    return requestApi.post('/login', { email, password })
}

const Signin = () => {
    const [disableBtn, setDisableBtn] = useState(false)
    const currentUserContext = useAdminInfo()
    const navigate = useNavigate()
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({ resolver: yupResolver(loginFormValidationSchema) })

    const mutation = useMutation(adminLogin, {
        onSuccess: ({ data }) => {
            setDisableBtn(true)
            localStorage.setItem(
                'adminToken',
                JSON.stringify(data?.meta?.tokenData)
            )
            localStorage.setItem('admin', JSON.stringify(data?.data))
            navigate(home)
            currentUserContext.setCurrentUser(data?.data)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    const handleOnSubmit = (data) => {
        const { email, password } = data
        mutation.mutate({
            email,
            password
        })
        setTimeout(() => {
            setDisableBtn(false)
        }, 3000)
    }

    return (
        <>
            {/* <div className="login-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="header-logo">
                                <Logo />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="login auth-page">
                <div className="container">
                    <div className="login auth-wrapper">
                        {/* <Row> */}
                            {/* <Col className="auth-image">
                                <LoginIcon />
                            </Col> */}
                            <Col className="welcome-form comman-form-col">
                                <div className="form-title text-center">
                                    <div className='card-logo'><Logo /></div>
                                    <h2>Welcome!</h2>
                                    <p className="text-center">
                                        Log in using your Frontline Admin Credential
                                    </p>
                                </div>
                                <Form onSubmit={handleSubmit(handleOnSubmit)}>
                                    <InputControl
                                        login
                                        label="Email Address"
                                        name="email"
                                        register={register}
                                        error={errors.email?.message}
                                    />

                                    <PasswordInput
                                        label="Password"
                                        name="password"
                                        error={errors.password?.message}
                                        register={register}
                                    />

                                    <Form.Group className="mb-3  text-end">
                                        <Link to={forgotpassword}>
                                            <span className="forgot-btn">
                                                Forgot password?
                                            </span>
                                        </Link>
                                    </Form.Group>
                                    <ButtonWithLoader
                                        isLoading={mutation?.isLoading}
                                        cssClass="common-btn login-btn comman-auth-btn"
                                    >
                                        <Button
                                            className="common-btn login-btn comman-auth-btn"
                                            type="submit"
                                            disabled={disableBtn}
                                        >
                                            {disableBtn
                                                ? 'Please Wait...'
                                                : 'Login'}
                                        </Button>
                                    </ButtonWithLoader>
                                </Form>
                            </Col>
                        {/* </Row> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Signin
